import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { IconStarSharp } from './icons'

let enable_submit

function SimpleChoiceItems({type, choices, name, numColumns, onChange})
{
    return (
	<div style={{display: 'grid',
		     gridTemplateColumns: [...Array(numColumns).keys()].map(x => 'auto').join(' ')}}>
	    {choices.map((choice, ci) =>
		<div key={ci} className="form-check">
		    <input className="form-check-input"
			   type={type}
			   value={choice}
			   name={name}
			   onChange={onChange}
			   id={"choice-" + name + "-" + ci}/>
		    <label className="w-100 form-check-label tertiary-text"
			   htmlFor={"choice-" + name + "-" + ci}>
			{choice}
		    </label>
		</div>)}
	</div>
    )
}

function CompanyInputField({frmid, stepId})
{
    const [step, setStep] = useState(null),
	  [value, setValue] = useState(0),
	  [values, setValues] = useState({})
    useEffect(() => {
	enable_submit(false)
	if ( frmid && stepId ) {
	    fetch(`/pub/form/${frmid}/${stepId}/`)
		.then(r => r.ok ? r.json() : Promise.reject(r))
		.then(json => {
		    setStep(json)
		})
		.catch(r => {
		    console.error('error in operation: %O, %O', r.status, r.statusText)
		    r.text().then(text => console.error('detail: %O', text))
		})
	}
    }, [frmid, stepId])
    useEffect(() => {
	if ( ! step ) return
	enable_submit(true)
	if ( step.valueRequired &&
	     !(step.dataFields[0].id in values &&
	       values[step.dataFields[0].id].length > 0) ) enable_submit(false)
	if ( step.domainRequired &&
	     !(step.dataFields[1].id in values &&
	       values[step.dataFields[1].id].length > 0) ) enable_submit(false)
	if ( step.jobfunctionRequired &&
	     !(step.dataFields[2].id in values &&
	       values[step.dataFields[2].id].length > 0) ) enable_submit(false)
	if ( step.jobtitleRequired &&
	     !(step.dataFields[3].id in values &&
	       values[step.dataFields[3].id].length > 0) ) enable_submit(false)
	if ( step.valueRequired &&
	     !(step.dataFields[4].id in values &&
	       values[step.dataFields[4].id].length > 0) ) enable_submit(false)
	if ( step.valueRequired &&
	     !(step.dataFields[5].id in values &&
	       values[step.dataFields[5].id].length > 0) ) enable_submit(false)
    }, [step, values])
    return step ? (
	<>
	    <div className="form-text" dangerouslySetInnerHTML={{__html:step.fieldDescr}}></div>
	    <div class="mb-2">
		<label class="form-label">
		    {step.nameLabel} {step.valueRequired && <IconStarSharp height="0.8rem"
									   width="0.8rem"
									   className="ms-2"/>}
		</label>
		<input type="text"
		       class="form-control"
		       id={"id-" + step.dataFields[0].id}
		       name={step.dataFields[0].id}
		       value={values[step.dataFields[0].id]}
		       onChange={ev => {
			   setValues(prev => ({...prev,
					       [step.dataFields[0].id]: ev.target.value}))
		       }}/>
	    </div>
	    <div class="mb-2">
		<label class="form-label">
		    {step.domainLabel} {step.domainRequired && <IconStarSharp height="0.8rem"
									      width="0.8rem"
									      className="ms-2"/>}
		</label>
		<input type="text"
		       class="form-control"
		       id={"id-" + step.dataFields[1].id}
		       name={step.dataFields[1].id}
		       onChange={ev => {
			   setValues(prev => ({...prev,
					       [step.dataFields[1].id]: ev.target.value}))
		       }}/>
	    </div>
	    <div class="mb-2">
		<label class="form-label">
		    {step.jobfunctionLabel} {step.jobfunctionRequired && <IconStarSharp height="0.8rem"
											width="0.8rem"
											className="ms-2"/>}
		</label>
		<input type="text"
		       class="form-control"
		       id={"id-" + step.dataFields[2].id}
		       name={step.dataFields[2].id}
		       onChange={ev => {
			   setValues(prev => ({...prev,
					       [step.dataFields[2].id]: ev.target.value}))
		       }}/>
	    </div>
	    <div class="mb-2">
		<label class="form-label">
		    {step.jobtitleLabel} {step.jobtitleRequired && <IconStarSharp height="0.8rem"
										  width="0.8rem"
										  className="ms-2"/>}
		</label>
		<input type="text"
		       class="form-control"
		       id={"id-" + step.dataFields[3].id}
		       name={step.dataFields[3].id}
		       onChange={ev => {
			   setValues(prev => ({...prev,
					       [step.dataFields[3].id]: ev.target.value}))
		       }}/>
	    </div>
	    {step.sizeChoices && (
		<div class="mb-2">
		    <label class="form-label">{step.sizeLabel}</label>
		    <SimpleChoiceItems type="radio"
				       name={step.dataFields[4].id}
				       choices={step.sizeChoices}
				       numColumns={step.numColumnsSize}
				       onChange={ev => {
					   setValues(prev => ({...prev,
							       [step.dataFields[4].id]: ev.target.value}))
				       }}/>
		</div>
	    )}
	    {step.industry && (
		<div class="mb-2">
		    <label class="form-label">{step.industryLabel}</label>
		    <SimpleChoiceItems type="radio"
				       name={step.dataFields[5].id}
				       name={step.dataFields[5].id}
				       choices={step.industry}
				       numColumns={step.numColumnsInd}
				       onChange={ev => {
					   setValues(prev => ({...prev,
							       [step.dataFields[5].id]: ev.target.value}))
				       }}/>
		</div>
	    )}
	</>
    ) : <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
}

(function() {
    const rootId = document.currentScript.getAttribute('data-rootid'),
	  el = document.getElementById(rootId),
	  stepId = el.getAttribute('data-stepid'),
	  frmid = el.getAttribute('data-frmid')
    enable_submit = (enable) => {
	if ( 'enable_submit' in window ) window.enable_submit(stepId, enable)
    }
    createRoot(el).render(<CompanyInputField frmid={el.getAttribute('data-frmid')}
					     stepId={stepId}/>);
})();
